import ProjectUser from "../../../../core/model2/project-user/project-user";
import {ProjectAccessMode} from "../../../../core/model2/project/types";

export enum TagType {
    GENERIC,
    PROJECT
}

// export enum ProjectAccessMode {
//     INHERITED   = 1,    // default mode - access is inherited from parent (PRIVATE)
//     EXPLICIT    = 2,    // DOES NOT inherit access - has to be set manually (!) maybe should name MANUAL ? (SHARED)
//     PUBLIC      = 3,    // always available for all company users - new one used in tags (PUBLIC)
// }

export const typeItems = [
    {
        items: [
            {
                typeId         : TagType.GENERIC,
                svgIcon50      : 'isvg-generic-tag',
                title          : 'Tag',
                description    : 'Create a tag to categorize and organize items across your workspace.'
            }, {
                typeId         : TagType.PROJECT,
                svgIcon50      : 'isvg-project-tag',
                title          : 'Project Tag',
                description    : 'A tag available within a specific folder or project, automatically accessible across its structure.'
            }
        ]
    }
];

export const accessOptions = [
    {
        id: ProjectAccessMode.PUBLIC_INHERITANCE_CHILDREN,      label: "Public",   icon: 'i5-globe',       description: 'Visible to all users'
    },
    {
        id: ProjectAccessMode.TAG_SHARED,    label: "Shared",   icon: 'i5-users', description: 'Shareable with others'
    },
    {
        id: ProjectAccessMode.INHERITANCE_PARENT_CHILDREN,   label: "Private",  icon: 'i5-lock',   description: 'Visible only to you'
    },
]

export type TypeInitParams = {
    projectId   : ID
    type        : TagType
    access      : ProjectAccessMode
    projectUsers: ProjectUser[]
    callback    : callback
}
